import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppModalService } from '@datachain/ui-sdk/components/app-modal';
import { catchError, Observable, throwError } from 'rxjs';

import {
	AppDeleteReportComponent,
	ConsumptionReport,
	DeleteReport,
} from '../ui/components/app-delete-report/app-delete-report.component';
import { ProjectStorage } from './project.storage';
import { DcRouteUrlBuilder } from './utils/dc-route-url-builder';

type DeleteErrorPayload = {
	code?: string;
	message?: string;
	delete_errors_report?: {
		total_deleted_element?: number;
		total_request_element?: number;
		element_dependencies?: Array<{
			v1?: string;
			v2?: Array<{
				id?: number;
				label?: string;
				type?: string;
				sub_type?: string;
			}>;
		}>;
	};
};

@Injectable()
export class DcDeleteErrorsInterceptor implements HttpInterceptor {
	public constructor(
		private readonly modalService: AppModalService,
		private readonly userSettings: ProjectStorage
	) {}

	public intercept(
		req: HttpRequest<unknown>,
		next: HttpHandler
	): Observable<HttpEvent<unknown>> {
		return next.handle(req).pipe(
			catchError((responseErr: HttpErrorResponse) => {
				if (req.method === 'DELETE' && responseErr?.error?.code === '40') {
					let elementsDeletedCount = 0;
					let nonDeletedElementsCount = 0;
					if (
						responseErr.error &&
						responseErr.error.delete_errors_report !== undefined &&
						responseErr.error.delete_errors_report.total_deleted_element !==
							undefined
					) {
						elementsDeletedCount =
							responseErr.error.delete_errors_report.total_deleted_element;
					}
					if (
						responseErr.error &&
						responseErr.error.delete_errors_report !== undefined &&
						responseErr.error.delete_errors_report.total_request_element !==
							undefined
					) {
						nonDeletedElementsCount =
							responseErr.error.delete_errors_report.total_request_element -
							elementsDeletedCount;
					}
					this.modalService.openPopup<DeleteReport>(
						AppDeleteReportComponent,
						{
							title: $localize`:i18n=@@delete.report:`,
							subTitle: '',
							width: '500px',
							height: '50%',
							code: 40,
							msg: responseErr?.error?.message ?? 'Unable to delete',
							details: this.adapt(responseErr.error),
							elementsDeleteRequestCount:
								responseErr.error.delete_errors_report.total_request_element ??
								0,
							elementsDeletedCount,
							nonDeletedElementsCount,
						},
						{
							disableClose: false,
						}
					);
				}
				return throwError(() => responseErr);
			})
		);
	}

	private adapt(errorResponse: DeleteErrorPayload): Array<ConsumptionReport> {
		return (
			errorResponse.delete_errors_report?.element_dependencies?.map<ConsumptionReport>(
				(eld) => {
					const projectId = this.userSettings.getProjectId();
					return {
						consumedElementLabel: eld.v1 ?? 'el',
						consumedWithin:
							eld.v2?.map((it) => ({
								label: it.label ?? 'consumer',
								type: it.type ?? 'unknown',
								elemUrl: DcRouteUrlBuilder.buildEditPageUrl(
									projectId,
									it.id,
									it.type,
									it.sub_type
								),
							})) ?? [],
					};
				}
			) ?? []
		);
	}
}
